import React from 'react'
import { useStyles } from './styles'
import { Chart } from '@devexpress/dx-react-chart-material-ui'

const PACE_COLOR_PALETTE = {
  Behind: '#FFD000',
  'On Track': '#05C34B',
  Ahead: '#B1FFDA'
}

const getBarColor = (barIndex, chartData) => {
  const pace = chartData.find((_el, idx) => idx === barIndex)
  return PACE_COLOR_PALETTE[pace.type]
}

const getPath = (x, width, y, y1) => `M ${x} ${y1}
   L ${width + x} ${y1}
   L ${width + x} ${y}
   L ${x + width / 2} ${y}
   L ${x} ${y}
   Z`

const Bar = ({ index, startVal, arg, maxBarWidth, barWidth, val, value, chartData }) => {
  const width = maxBarWidth * barWidth
  const classes = useStyles()
  return (
    <React.Fragment>
      <path d={getPath(arg - width / 2, width, val, startVal)} fill={getBarColor(index, chartData)} visibility='visible' />
      <Chart.Label
        x={arg}
        y={val - 15}
        dominantBaseline='middle'
        textAnchor='middle'
        style={{
          fill: '#000000',
          fontFamily: 'National',
          fontSize: '18px',
          fontWeight: 500
        }}
        className={classes.label}
      >
        {value}
      </Chart.Label>
    </React.Fragment>
  )
}

export default Bar
